<template>
  <div class="admin-schedule-bars">
    <header-title title="Horarios de Menus"></header-title>

    <Loader :dialog-loader="dialogLoader" message="Cargando..."></Loader>

    <!-- MENU GROUP TIMINGS-->
    <template v-if="scheduleByMenuGroup && scheduleByMenuGroup.length > 0">
      <template v-if="display">
        <div
          v-for="(menuGroupSchedule, index) in scheduleByMenuGroup"
          :key="`menu_schedule_${index}`"
        >
          <schedule
            v-if="existMenuGroup(menuGroupSchedule.menuId)"
            :title="
              `Horario de ${getScheduleMenuGroupName(menuGroupSchedule.menuId)}`
            "
            :display="display"
            :schedule-collection="
              mapMenuGroupSchedule(menuGroupSchedule.schedule)
            "
            @saveSchedule="saveMenuGroupHour"
            :menu-schedule="menuGroupSchedule"
          />
        </div>
      </template>
    </template>
  </div>
</template>

<script>
import { menuGroupCollection } from "@/collections/menuGroup";
import Loader from "@/components/common/Loader";
import HeaderTitle from "@/components/admin/common/HeaderTitle.vue";
import Schedule from "@/components/admin/schedule/Schedule.vue";
import {
  scheduleMenuGroupCollection,
  updateScheduleMenuGroup
} from "@/collections/scheduleMenuGroup";

const DAYS = [
  {
    name: "Lunes",
    value: 1
  },
  {
    name: "Martes",
    value: 2
  },
  {
    name: "Miercoles",
    value: 3
  },
  {
    name: "Jueves",
    value: 4
  },
  {
    name: "Viernes",
    value: 5
  },
  {
    name: "Sabado",
    value: 6
  },
  {
    name: "Domingo",
    value: 0
  }
];

export default {
  name: "ScheduleMenuGroup",
  components: { Loader, HeaderTitle, Schedule },
  data() {
    return {
      days: DAYS,
      display: false,
      menuGroup: [],
      scheduleByMenuGroup: [],
      dialogLoader: true
    };
  },
  firestore() {
    return {
      menuGroup: menuGroupCollection,
      scheduleByMenuGroup: scheduleMenuGroupCollection
    };
  },
  mounted() {
    let self = this;

    setTimeout(() => {
      self.display = true;
      this.dialogLoader = false;
    }, 300);
  },
  methods: {
    mapMenuGroupSchedule(schedule) {
      let cloneMenuSchedule = JSON.parse(JSON.stringify(schedule));
      let array = [];
      // eslint-disable-next-line no-unused-vars
      for (const [key, value] of Object.entries(cloneMenuSchedule)) {
        array.push(value);
      }
      array.push(array.shift());
      return array;
    },
    getScheduleMenuGroupName(menuId) {
      let menuGroup = this.menuGroup.find(x => x.id === menuId);
      return menuGroup !== undefined ? menuGroup.name : "";
    },
    existMenuGroup(menuId) {
      return this.menuGroup.find(x => x.id === menuId) !== undefined;
    },
    async saveMenuGroupHour(event, schedule, day, range, shift) {
      try {
        let selectDay = this.days[day].value;
        schedule.schedule[selectDay][shift][range] = parseFloat(event);
        await updateScheduleMenuGroup(schedule.id, schedule);

        this.showSuccesMessage();
      } catch (error) {
        this.setlogError(
          "update_schedule_menu_group",
          "Obtained error message in saveMenuGroupHour()",
          error.stack,
          this.$options.name
        );
        this.showErrorMessage("Algo salió mal");
      }
    },
    showSuccesMessage() {
      this.showSuccessMessage("Se ha actualizado la hora");
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss"></style>
